import { useI18n } from '~/app/i18n/i18n';

export const RimFallbackSvg = () => {
	const { i18n } = useI18n();
	return (
		<svg
			role="img"
			aria-label={i18n('ngc.a11y.placeholderImage')}
			width="68"
			height="68"
			viewBox="0 0 68 68"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<ellipse cx="34" cy="64" rx="16.1111" ry="1" fill="#D9D9D9" />
			<path
				d="M63 34.0177C63 50.0242 50.0163 63 34 63C17.9837 63 5 50.0242 5 34.0177C5 18.0112 17.1194 4.20741 34 5.03543C50.0163 5.03543 63 18.0112 63 34.0177Z"
				fill="black"
				fillOpacity="0.05"
			/>
			<path
				d="M62.966 33.845C62.966 17.9617 49.3494 5.03223 32.075 5.03223C16.078 5.03223 5.03418 17.9617 5.03418 33.845C5.03418 49.7282 16.5978 62.9671 32.5954 62.9671C48.593 62.9671 62.966 51.3907 62.966 33.845Z"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M32.5844 62.9678C48.2622 62.9678 62.3487 51.3914 62.3487 33.8456C62.3487 17.9617 49.0043 5.03223 32.075 5.03223"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M32.5613 62.9678C47.5208 62.9678 60.9621 51.3914 60.9621 33.8456C60.9621 17.9617 48.2288 5.03223 32.075 5.03223"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M32.5422 62.9678C46.9035 62.9678 59.8067 51.3914 59.8067 33.8456C59.8067 17.9617 47.5829 5.03223 32.075 5.03223"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M32.5149 62.9678C46.0387 62.9678 58.1895 51.3914 58.1895 33.8456C58.1888 17.9617 46.6785 5.03223 32.075 5.03223"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M44.7913 42.3109C45.8171 39.7781 46.3886 36.9682 46.3886 34.0093C46.3886 33.0784 46.332 32.1617 46.2229 31.2644"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M25.7837 54.0325C26.5878 54.1537 27.409 54.2162 28.2425 54.2162C30.6843 54.2162 33.0128 53.6792 35.1388 52.7058"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M10.5798 38.6584C11.2858 41.997 12.7351 45.0165 14.7233 47.4874"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M18.2168 17.1636C15.6631 19.0524 13.5638 21.6419 12.1396 24.6859"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M39.2918 17.9784C36.8044 15.8485 33.8067 14.4213 30.5383 13.9617"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M28.4511 55.2656C38.8778 55.2656 47.3304 45.7485 47.3304 34.0086C47.3304 22.2688 38.8778 12.7517 28.4511 12.7517C18.0243 12.7517 9.57178 22.2688 9.57178 34.0086C9.57178 45.7485 18.0243 55.2656 28.4511 55.2656Z"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M25.1616 44.281C27.381 47.5467 30.6269 50.0815 34.4465 51.4397"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M22.0337 32.7754C22.0071 33.177 21.9941 33.5825 21.9941 33.9912C21.9941 35.1973 22.1115 36.3763 22.3352 37.518"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M25.6172 23.0601C24.3356 24.7845 23.3487 26.7345 22.7314 28.8379"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M36.2729 15.8801C34.5398 16.3713 31.9398 17.5729 30.4761 18.3555"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M29.0882 36.2694C30.1814 36.2694 31.0675 35.2734 31.0675 34.0447C31.0675 32.8161 30.1814 31.8201 29.0882 31.8201C27.9951 31.8201 27.1089 32.8161 27.1089 34.0447C27.1089 35.2734 27.9951 36.2694 29.0882 36.2694Z"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M46.3455 31.2427L33.1729 35.3922L31.1506 33.4815L31.2659 33.0444L38.141 26.8198"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path d="M39.2966 17.9734L37.3323 34.0816" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path
				d="M30.5729 13.8779C30.2837 15.6797 30.6309 27.6932 30.9194 29.1127L28.9551 31.024C28.9551 31.024 26.5958 25.484 24.7495 20.7279"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path d="M18.2095 17.1545L30.5151 23.8704" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path
				d="M12.0273 24.635C12.0273 24.635 22.5419 29.1127 24.8534 29.7676L26.1821 32.771L15.3783 32.9347"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path d="M10.5254 38.6688L19.8846 27.8569" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path
				d="M35.1373 52.7019C35.1373 52.7019 29.2444 42.2723 28.4934 40.0883L29.88 36.8123L37.0443 43.4739"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path d="M44.6697 42.3271L30.573 44.4022" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path
				d="M14.6853 47.5146C18.0362 42.491 22.7158 36.9213 23.4095 36.2115L26.7024 36.1567L22.6006 46.859"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M25.7775 54.0674C25.7775 54.0674 20.5775 42.1087 19.8845 40.4165"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M53.9136 28.876C53.9136 28.876 56.725 27.4565 57.1104 27.4926C57.4957 27.5287 58.7282 27.8929 60.0759 30.0041"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M53.1819 25.7819C54.5296 24.8355 56.4176 24.0343 56.6481 24.1439C56.8786 24.2534 57.3799 24.7266 57.3799 24.7266"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M51.9492 22.4329C53.0275 21.5955 54.4142 20.4674 55.3002 20.7581C56.1862 21.0489 57.4957 22.0687 58.4199 23.4153"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M50.5244 19.6301C51.4486 18.647 53.1435 17.6278 53.683 17.7735C54.2225 17.9192 54.6072 18.2834 54.6072 18.2834"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M48.7136 16.6816C49.6767 15.2621 51.448 13.3327 54.9149 16.7177"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M46.6729 14.3511C47.2124 13.4048 48.6754 11.8396 50.2161 12.7859"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M44.3232 11.9487C45.3634 10.0193 46.634 9.65505 48.9067 11.0023"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M41.8584 10.2017C42.475 9.0368 43.3992 7.94478 45.2475 8.78217"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M39.1233 8.70923C39.5087 7.58047 39.8163 6.59804 41.28 6.88877"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M36.5042 7.54377C36.7354 6.37891 37.3513 5.76005 38.1991 5.869"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M33.5386 6.81585C33.5768 5.86952 34.1933 5.21393 35.0023 5.28677"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M30.8042 6.59732C30.8813 5.61424 31.1507 5.17782 31.6131 5.10498"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M27.838 6.63413C27.7228 5.90633 27.9533 5.32358 28.2234 5.25073"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M25.1425 6.99766C25.0272 6.4149 25.0272 5.94174 25.3348 5.8689"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M22.2922 7.83521C22.0999 7.25246 22.061 6.88889 22.2922 6.7793"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M19.9043 8.85432C19.7119 8.454 19.5189 8.08978 19.7501 7.94409"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M17.2851 10.3833C17.131 10.2015 16.8227 9.69155 17.0928 9.50977"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M15.1667 11.9853C15.0515 11.8036 14.8584 11.6579 14.7432 11.4026"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path d="M12.9322 14.0236L12.4705 13.6233" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path d="M11.1611 16.0259L10.7375 15.8074" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path d="M9.4279 18.6469L9.00366 18.4651" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path d="M8.1566 20.9767L7.77124 20.8311" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path d="M6.88593 23.9621L6.57764 23.8164" stroke="#B3B3B3" strokeWidth="0.5" strokeMiterlimit="10" />
			<path
				d="M54.2219 32.662C55.7627 31.8974 57.9582 30.6597 58.8053 31.6789"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M54.2219 35.9381C56.5327 35.1736 58.42 33.1713 60.3072 36.8116"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M53.6055 39.5061C55.3004 39.2875 57.5341 37.7952 58.6895 38.8872"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M53.0276 42.6726C54.9148 42.4908 58.497 40.27 58.5741 44.1649"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M51.6799 46.1312C53.6443 46.0951 55.9551 45.0392 56.6487 45.8038"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M50.4084 48.8611C52.8352 49.4072 55.9931 47.3688 55.7619 50.2806"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M48.4443 51.8832C49.6768 52.3563 52.4882 51.5557 53.2201 51.9193"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M46.5188 54.0305C48.0978 54.8679 51.4487 53.5206 51.5647 55.1954"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M44.2073 56.4331C45.2474 56.8334 46.0563 56.7606 47.7506 56.7973"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M41.8584 58.1807C42.7826 58.581 44.4775 58.9813 47.0195 58.8724"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M39.2773 59.8186C40.1633 60.1828 41.6652 60.6192 43.3213 60.8017"
				stroke="#B3B3B3"
				strokeWidth="0.5"
				strokeMiterlimit="10"
			/>
		</svg>
	);
};
